import { en_us } from "../en_us";

export const en_us_snf = {
  ...en_us
};
